'use client';

import { useContext } from 'react';
import { ConfirmContext } from './ConfirmContext';
import type { ConfirmContextType } from './types';

export const useConfirm = (): ConfirmContextType => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }
  return context;
};
